import { Navigate } from "react-router-dom";
import Reveal from "../components/Reveal";
import classes from "./PageShell.module.css";
import { getSecretAccess } from "../utils/secretGate";

const youtubeVideos = [
  {
    id: "O32rSAxSIVA",
    title: "Vlog03|Went to a farm market, made hwachae for dinner tonight",
  },
  {
    id: "ShVOyhPtpeg",
    title: "Vlog02|Unboxing ASMR, iPhone, Apple watch and Macbook Pro",
  },
  {
    id: "gMtf7yYuhgA",
    title:
      "Vlog01|Hotpot for mid-autumn festival! Go through in parallel world, eat with two tables of friends",
  },
];

const socialLinks = [
  {
    name: "TikTok",
    handle: "@achennnnn",
    href: "https://www.tiktok.com/@achennnnn?is_from_webapp=1&sender_device=pc",
    blurb: "Another place to watch my videos.",
  },
  {
    name: "X",
    handle: "@achenslife",
    href: "https://x.com/achenslife?s=21",
    blurb: "Mainly crypto.",
  },
];

const Secret = () => {
  if (!getSecretAccess()) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <main className={classes.page}>
        <Reveal as="section" className={classes.card}>
          <p className={classes.eyebrow}>Secret</p>
          <h1>Hi.</h1>
          <p>This page is showing you my life.</p>
          <p>I will show you my vlogs, cooking recipes here.</p>
        </Reveal>

        <Reveal as="section" className={classes.card}>
          <div className={classes.sectionHeading}>
            <p className={classes.eyebrow}>Youtube</p>
          </div>
          <div className={classes.videoGrid}>
            {youtubeVideos.map((video) => (
              <article key={video.id} className={classes.videoCard}>
                <div className={classes.videoFrame}>
                  <iframe
                    src={`https://www.youtube.com/embed/${video.id}`}
                    title={video.title}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
                <div className={classes.videoCopy}>
                  <h3>{video.title}</h3>
                  <div className={classes.videoFooter}>
                    <a
                      href={`https://www.youtube.com/watch?v=${video.id}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Watch on YouTube
                    </a>
                  </div>
                </div>
              </article>
            ))}
            <article className={`${classes.videoCard} ${classes.teaserCard}`}>
              <div className={classes.teaserCopy}>
                <div className={classes.teaserBadge}>More videos on the way</div>
                <h3>Still cooking up the next upload</h3>
                <div className={classes.videoFooter}>
                  <p>I&apos;ll be back when life gives me time to record more.</p>
                  <span>Check back later.</span>
                </div>
              </div>
            </article>
          </div>
        </Reveal>

        <Reveal as="section" className={classes.card}>
          <div className={classes.sectionHeading}>
            <p className={classes.eyebrow}>Social</p>
            <h2>Find me elsewhere</h2>
          </div>
          <div className={classes.socialGrid}>
            {socialLinks.map((item) => (
              <article key={item.name} className={classes.socialCard}>
                <div className={classes.socialCopy}>
                  <p className={classes.socialLabel}>{item.name}</p>
                  <h3>{item.handle}</h3>
                  <p>{item.blurb}</p>
                </div>
                <a href={item.href} target="_blank" rel="noreferrer">
                  Open {item.name}
                </a>
              </article>
            ))}
          </div>
        </Reveal>
      </main>
    </>
  );
};

export default Secret;
